/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
/**
 * RestDevelopmentApi - axios parameter creator
 * @export
 */
export const RestDevelopmentApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary clean user state
         * @param {string} email 
         * @param {boolean} [onlyQuizRemove] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cleanUserState: async (email: string, onlyQuizRemove?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('cleanUserState', 'email', email)
            const localVarPath = `/api/development/users/clean-state`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            if (onlyQuizRemove !== undefined) {
                localVarQueryParameter['onlyQuizRemove'] = onlyQuizRemove;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RestDevelopmentApi - functional programming interface
 * @export
 */
export const RestDevelopmentApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RestDevelopmentApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary clean user state
         * @param {string} email 
         * @param {boolean} [onlyQuizRemove] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cleanUserState(email: string, onlyQuizRemove?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cleanUserState(email, onlyQuizRemove, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestDevelopmentApi.cleanUserState']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RestDevelopmentApi - factory interface
 * @export
 */
export const RestDevelopmentApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RestDevelopmentApiFp(configuration)
    return {
        /**
         * 
         * @summary clean user state
         * @param {string} email 
         * @param {boolean} [onlyQuizRemove] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cleanUserState(email: string, onlyQuizRemove?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.cleanUserState(email, onlyQuizRemove, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RestDevelopmentApi - interface
 * @export
 * @interface RestDevelopmentApi
 */
export interface RestDevelopmentApiInterface {
    /**
     * 
     * @summary clean user state
     * @param {string} email 
     * @param {boolean} [onlyQuizRemove] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestDevelopmentApiInterface
     */
    cleanUserState(email: string, onlyQuizRemove?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * RestDevelopmentApi - object-oriented interface
 * @export
 * @class RestDevelopmentApi
 * @extends {BaseAPI}
 */
export class RestDevelopmentApi extends BaseAPI implements RestDevelopmentApiInterface {
    /**
     * 
     * @summary clean user state
     * @param {string} email 
     * @param {boolean} [onlyQuizRemove] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestDevelopmentApi
     */
    public cleanUserState(email: string, onlyQuizRemove?: boolean, options?: RawAxiosRequestConfig) {
        return RestDevelopmentApiFp(this.configuration).cleanUserState(email, onlyQuizRemove, options).then((request) => request(this.axios, this.basePath));
    }
}

